module.exports = __webpack_public_path__ + "img/status.d773f3b9.svg";